<template>
  <transition name="modal">
    <modal-layout>
      <content-card :data-modal="infoModal" :social-media="socialMedia"></content-card>
    </modal-layout>
  </transition>
</template>
<script>
import ModalLayout from '@/layouts/ModalLayout.vue';
import ContentCard from '@/components/ContentCard.vue';
import { contactInfo, socialMedia } from '@/data/contact';

export default {
  name: 'ContactModal',
  components: {
    ModalLayout,
    ContentCard,
  },
  data() {
    return {
      infoModal: contactInfo,
      socialMedia,
    };
  },
};
</script>
<style scoped>

</style>
